import React from "react";
export default function Contact() {
  return (
    <div className="michroma-regular" style={{ textAlign: "center" }}>
      Contact
    </div>
  );
}
